module.exports = __webpack_public_path__ + "img/141.94eca5d6.jpg";